import { render, staticRenderFns } from "./RemoteServiceEditor.vue?vue&type=template&id=1dcd8884"
import script from "./RemoteServiceEditor.vue?vue&type=script&lang=js"
export * from "./RemoteServiceEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports